import { memo } from "react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

// MUI
import { Stack } from "@mui/material";
import { TabPanel } from "@mui/lab";

function CustomTabPanel(props) {
	const { children, selected, index, additionalProps } = props;
	return (
		<Stack
			style={{
				width: "100%",
				left: 0,
				display: index !== selected ? "none" : "inline-block",
			}}
			{...additionalProps}
		>
			{children}
		</Stack>
	);
}

function TabsPanelsContent(props) {
	const { content, selected, containerProps, tabPanelProps, useMUITabPanel } = props;
	return (
		<Stack {...containerProps}>
			{content.map((children, key) => {
				const newChildren = typeof children === "function" ? children(selected) : children;
				if (useMUITabPanel) {
					return (
						<TabPanel key={uuidv4()} value={key} className={"!w-full !p-0"}>
							{newChildren}
						</TabPanel>
					);
				}
				return (
					<CustomTabPanel key={newChildren?.key} value={key} index={key} selected={selected} additionalProps={tabPanelProps}>
						{newChildren}
					</CustomTabPanel>
				);
			})}
		</Stack>
	);
}

const TabsPanels = memo(TabsPanelsContent);
export default TabsPanels;

TabsPanelsContent.propTypes = {
	content: PropTypes.array,
	selected: PropTypes.number,
	containerProps: PropTypes.object,
	tabPanelProps: PropTypes.object,
	useMUITabPanel: PropTypes.bool,
};

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	selected: PropTypes.number,
	index: PropTypes.number,
	additionalProps: PropTypes.object,
};

TabsPanels.propTypes = {
	content: PropTypes.array,
	selected: PropTypes.number,
	containerProps: PropTypes.object,
	tabPanelProps: PropTypes.object,
	useMUITabPanel: PropTypes.bool,
};
